module.exports = __webpack_public_path__ + "media/images/pulse-a8acbd5c12015348aa3cf8968e34b606.svg";